module.exports = __webpack_public_path__ + "img/toutu_zhaobiaoxinxi@1x.95bd7f30.png";